export type Quality = 'low' | 'medium' | 'high';

const DPR_CAP: Record<Quality, number> = { low: 1, medium: 1.5, high: 2 };

/** Render resolution = device pixel ratio capped by the quality profile (plan §4.1, §7). */
export function computeResolution(devicePixelRatio: number, quality: Quality): number {
  const dpr = Number.isFinite(devicePixelRatio) && devicePixelRatio > 0 ? devicePixelRatio : 1;
  return Math.min(dpr, DPR_CAP[quality]);
}

/** WebGL capability check used before booting Pixi (S01 “unsupported” screen otherwise). */
export function detectWebGL(doc: Document = document): 'webgl2' | 'webgl' | null {
  try {
    const canvas = doc.createElement('canvas');
    if (canvas.getContext('webgl2')) return 'webgl2';
    if (canvas.getContext('webgl')) return 'webgl';
  } catch {
    // fall through
  }
  return null;
}
